export default __webpack_public_path__ + "static/media/email-icon.6edc51f4.svg";